import { Injectable, Inject } from 'ng-metadata/core';
import {ConfigurationUtil} from '../../../nddUtils/configurationUtil.service';
import {ArrayUtils} from '../../../nddUtils/arrayUtils.service';
import {JournalsService} from "../../../journals/journals.service";
import {DatabasesService} from "../../../journals/databases.service";
import {BriefResultService} from '../../briefResult/briefResult.service';
import {MappingTablesCache} from '../../../mappingTablesCache/mappingTablesCache.service';
import {NewspapersService} from '../../../newspapers/newspapers.service';
import {getLegantoTemplateUrl} from '../../../appConfig/appConfigForward';
import { PartiallyTranslatedLocalFieldsUtil } from '../../../nddUtils/partiallyTranslatedLocalFieldsUtil.service';
const isArray = require('lodash/isArray');
const  isMatch  = require('lodash/isMatch');
const forEach = require('lodash/forEach');
const cloneDeep= require('lodash/cloneDeep');
const get= require('lodash/get');

export const DO_NOT_HIGHLIGHT_FIELD = 'DoNotHighlightField';

@Injectable()
export class ServiceDetailsService {
	private fieldsDetails: any;
    private basicFieldsDetails: any;
	private hlTable: any;
	private fcdTable: any; // Field chains display

	constructor (private configurationUtil: ConfigurationUtil,
				 private arrayUtils:ArrayUtils ,
				 @Inject('$translate') private $translate,
				 private journalsService: JournalsService,
				 private briefResultService: BriefResultService,
				 private mtCache:MappingTablesCache,
                 private databasesService: DatabasesService,
                 private newspapersService: NewspapersService,
				 @Inject('$q') private $q: ng.IQService,
				 private partiallyTranslatedLocalFieldsUtil : PartiallyTranslatedLocalFieldsUtil) {

		this.configurationUtil = configurationUtil;
		this.arrayUtils = arrayUtils;

		let isSuprima = this.configurationUtil.isSuprima();

		this.hlTable = this.mtCache.getTable(this.mtCache.tables.HYPERTEXT_LINKING_DEFINITIONS);
		this.fcdTable = this.mtCache.getTable(this.mtCache.tables.FIELD_CHAINS_DISPLAY);

        let dFields = ['vertitle', 'creator', 'contributor', 'subject', 'lds', 'identifier', 'relation', 'source'];

		this.fieldsDetails = {
			vertitle : {
				isLinkable : true,
				getKey : ()=> {
					return 'vertitle';
				},
			},
			creator : {
				isLinkable : true,
				getKey : (label) =>{
					return label;
				},
				splitValue: ';'
			},
			contributor : {
				isLinkable : true,
				getKey : ()=> {
					return 'creator';
				},
				splitValue: ';'
			},
			subject : {
				isLinkable : true,
				getKey : (label) =>{
					return 'sub';
				},
				splitValue: ';'
			},
			lds : {
				isLinkable : configurationUtil.getSystemConfiguration('Use local fields 30-39 as lateral links') === 'Y',
				getKey : (label)=> {
					return label.replace('lds', 'lsr');
				}
			},

			/* complex type */
			identifier : {
				complexType : 'id',
				splitValue: ';'
			},
			relation : {
				complexType : 'relatedTitle'
			},


			source : {
				isCollapsible : (values)=> {
					let isCollapsible= false;
					values.forEach((value) =>{
						if (value.match(/ProQuest LLC All rights reserved/i)) {
							isCollapsible=true;
							return;
						}
					});
					return isCollapsible;
				}
			}
		};
        this.basicFieldsDetails = cloneDeep(this.fieldsDetails);

        this.fieldsDetails = this.getFieldDetails(this.fieldsDetails, dFields);
	}

    get doNotHighlightField(){
       return DO_NOT_HIGHLIGHT_FIELD;
    }
    
    public getTextFromVal(value) {
         if (value.includes('$$Q')) {
            let text = value.split('$$Q')[0];//text
            if (text.includes('$$C')) {
                text = this.getSubfieldFromVal(text, '$$V');
            }
            return text;
        } else if (value.includes('$$Z')) {
            let text = value.split('$$Z')[0];//text
            if (text.includes('$$C')) {
                text = this.getSubfieldFromVal(text, '$$V');
            }
            return text;
        } else if (value.includes('$$V')) {
            return this.getSubfieldFromVal(value, '$$V');
        } else if (value.includes('$$R')) {
            return value.split('$$R')[0];
        } else if (this.partiallyTranslatedLocalFieldsUtil.isPartiallyTranslated(value)){
			return this.partiallyTranslatedLocalFieldsUtil.removeTranslationTags(value);
		} else {
            return value;
        }
    }

    public getSubfieldFromVal(value, subfield) {

        if (this.isSubfieldExist(value, subfield)) {
            let val = value.split(subfield)[1];
            if (val.indexOf('$$')!==-1) {
                val = val.substring(0, val.indexOf('$$'))
            }
            return val;
        } else {
            return value;
        }
    }
    
    public createLegantoLink(item, crsInfo){
        let courseName = (this.getSubfieldFromVal(crsInfo, '$$R')).trim();
        let courseSection = '.' + (this.getSubfieldFromVal(crsInfo, '$$N')).trim();
        courseName = courseName.split('$$M')[0].trim();
        
        let candidateCrsSection;
        if (courseName.lastIndexOf(courseSection) >=0) {
            candidateCrsSection = courseName.substring(courseName.lastIndexOf(courseSection), courseName.length);
        }
         
        if (candidateCrsSection === courseSection) {
            courseName =  courseName.substring(0, courseName.lastIndexOf(courseSection));
        }
        
        let legantoTemplateUrl = getLegantoTemplateUrl();
        if (!legantoTemplateUrl) {
            let links = get(item, 'delivery.link');
            if (!links) {
                return;
            }
 
            let legantoLink = links.filter(link => {
                return link.displayLabel === 'leganto_url' && 
                       link.hyperlinkText && 
                       link.hyperlinkText.trim() === courseName});

            if (legantoLink && legantoLink.length > 0) {
                 return legantoLink[0].linkURL;
            }
        } else {
            let link = legantoTemplateUrl.replace("<course_code>", encodeURIComponent(courseName));
            return link;
        }
    }
   
    public getDisplayedCourseCode(crsInfo) {
        let courseName = (this.getSubfieldFromVal(crsInfo, '$$M')).trim();
        if (!courseName || courseName === crsInfo) {
            return crsInfo.split('$$R')[0].trim();
        }
        return courseName;
    }
    
    private isSubfieldExist(value, subfield) {
        return value.includes(subfield);
    }
    
	private getFieldDetails(basicFields, dFields){
		let fDetails={};

		let chainDisplayObj = {};
		this.fcdTable.forEach((row) => {chainDisplayObj[row.target] = row});

		this.hlTable.forEach((row, index)=>{
			let key = row.target;
			let contextField = row.source3? row.source3 : 'ANY';
			let fDetail ={};

		   if('includes' !== row.target && 'relatedwork' !== row.target){
              fDetail={
				isLinkable:true,
				context: contextField,
				getKey : (label) =>{
					return row.source1;
				},
				splitValue: ';',
				operator: row.source2
			 };
          }else{
            fDetail={
                isLinkable:true,
                context: contextField,
                getKey : (label) =>{
                    return row.source1;
                },
                operator: row.source2
            };
          }
			let complexType = '';

			if (key === 'identifier') {
				complexType =  'id';
			}

			if (key === 'relation') {
				complexType =  'relatedTitle';
			}

			if (complexType !== '') {
				fDetail={
					isLinkable:true,
					context: contextField,
					getKey : (label) =>{
						return row.source1;
					},
					operator: row.source2,
					complexType: complexType
				};
			}
			fDetail['facetField'] = row.source4;
			let chainDisplayRow = get(chainDisplayObj, key);
			if(chainDisplayRow && chainDisplayRow.source1){
				fDetail['chainDelimiter'] = chainDisplayRow.source1;
			}
			fDetails[key] = fDetail;
		});
		//let currIndex = this.hlTable.length;

		dFields.forEach((field)=>{
			if (!fDetails[field]){
				fDetails[field] = basicFields[field];
				//currIndex ++;
			}
		});

		return fDetails;
	}

	private filterEmpty(e) {
		return e.label;
	}

	parseItem(res, item, isAlmaViewer) {
		let delimiter = this.configurationUtil.getFullViewConfiguration().delimiter + ' ';

		let labels = item.items.split(','); // get all labels, e.g "items": "creator,contributor"
		let values = [];					// holds all values for current label, it can be multiple

		let isToTranslate = item.useTranslations;
		let label = labels[0];
		let isCollapsible = false;
		if (isAlmaViewer && !item.displayInViewer){
			return {label:null, values:null, isCollapsible:null, showMore:null};
			}

		labels.forEach((curLabel) =>{

			let val = {
				delimiter: '',
				key:null,
				keyt: curLabel,
				isLinkable:false,
				values: [],
				operator: '',
				facetField: '',
				isFacetExact: false,
				chainDelimiter: null
			};

            let curRes = (curLabel === ('source' || 'language')) ? res.pnx.display[curLabel] : angular.copy(res.pnx.display[curLabel]);
            //no such elements in results
            if (!curRes) {
                return ;
            }
			let config = this.getFieldConfig(curLabel);
			if (config) {
                let recordId = res.pnx.control.recordid[0];
                let context = res.context
                let isPCRecord = false;
                if (context === "PC" || (recordId && recordId.startsWith("TN_"))){
                    isPCRecord = true;
                }
                let key = this.isLdsField(curLabel) ? 'lds' : curLabel

                if(!isPCRecord){
                    if(this.configurationUtil.isSuprima()){
						if(!this.checkMoreThanOneOccurance(curRes, ['$$Q','$$R','$$V','$$Z'])){
							delete config.splitValue;
						}
                    }else if(this.basicFieldsDetails[key]){
                        config.splitValue = this.basicFieldsDetails[key].splitValue;
                    }
                }
				if (config.getKey) {
					val.key = config.getKey(curLabel); //for linkable field
				}

				val.facetField = config.facetField;

				if(config.operator){
					if(config.operator !== 'facet exact'){
						val.operator = config.operator;
					}else{
						val.operator = 'exact';
						val.isFacetExact = true;
					}
				}else{
					val.operator = 'exact';
				}
				
				let isLinkableForContext = config.context==='ANY' || res.context===config.context;

				val.isLinkable = config.isLinkable && isLinkableForContext;
                if(this.journalsService.isJournalSearch() || this.databasesService.isDBSearch()
						|| this.newspapersService.isNewspapersSearch() || this.newspapersService.isNewspaperItem(res)){
					val.isLinkable = false;
				}


				if (this.getFieldConfig(label) && this.getFieldConfig(label).noLabel) {
					label = '';
				}

				if(config.chainDelimiter && !isPCRecord){
					val.chainDelimiter = config.chainDelimiter;
				}
				else if (config.splitValue) {
                    curRes = this.arrayUtils.flattenDeep(
                        curRes.map((value, index, array) => value.split(config.splitValue))
					);
				}
				if (config.complexType) {
                    curRes = curRes.map((value, index, array)=>{
						return value[config.complexType] || value;
					});
				}
				if(config.isCollapsible) {
					isCollapsible = config.isCollapsible(curRes);
				}
			}



			if(curLabel === 'source'){
				curRes= curRes.filter((res)=>res.length > 0);
				curRes = curRes.map((source) => this.briefResultService.remove$$OValues(source));
				curRes = curRes.map((res) => this.parseSourceCodes(res));
				curRes.forEach((res,index) => {
					let defaultTranslation: string = '';
					defaultTranslation = res.replace('fulldisplay.datasource.','');
					
					curRes[index] = (/\s|\./.test(defaultTranslation)) ? defaultTranslation : this.$translate.instant(res);

				});
				
			}
			else if(curLabel === 'language'){
				curRes = curRes.slice();
				curRes[0].split(';').map((l,index)=>{
				    curRes[index] = this.$translate.instant('lang.'+l.trim());
				});
			} else if(curLabel === 'crsinfo') {
                let enableLegantoLink;
                let fullViewConfiguration = this.configurationUtil.getFullViewConfiguration();
                if(fullViewConfiguration) {
                    enableLegantoLink = fullViewConfiguration.enablelegantolink;
                }
                let crsinfo = get(res,'pnx.display.crsinfo[0]');
 				if((enableLegantoLink && crsinfo && crsinfo.indexOf('$$R')>-1) || getLegantoTemplateUrl()) {
				    val.isLinkable = true;
                    
				}
			} else if (curLabel === 'type') {
				if (!isToTranslate) {  
					curRes.forEach((res, i) => {
                        curRes[i] = this.$translate.instant('mediatype.' + res);
                        /*this.$translate('mediatype.' + res, [], '', res).then((translation) => {
                            curRes[i] = translation;
                        });*/
					});
				}
			}

			if (isArray(curRes)) {
				val.values = curRes;
			} else {
				val.values = [curRes];
			}


            val.values.forEach((value, index, array)=> {
				if (isToTranslate) {
                    if (curLabel.startsWith('lds') && this.partiallyTranslatedLocalFieldsUtil.isPartiallyTranslated(value)) {
						this.partiallyTranslatedLocalFieldsUtil.parsePartiallyTranslatedLocalField(value).then((parsedVal) => {
							val.values[index] = parsedVal;
						})
                    } else if (curLabel.startsWith('lds')) {
                        this.$translate(value.toLowerCase(), [], '', value).then((translation)=>{
							val.values[index] =translation;
						});
                    } else {
						this.$translate(value.toLowerCase(), [], '', '').then((translation)=>{
							val.values[index] =translation;
						});
					}	
				}
				this.parseValue(value).then((parsedVal)=> {
					if (parsedVal != value){
						val.values[index] = parsedVal;
					}
				});
			});

			val.delimiter = delimiter;
			values.push(val);

		},this);

		if (values.length === 0) {
			return {label:null, values:null, isCollapsible:null, showMore:null};
		}

		return {label:label, values:values, isCollapsible:isCollapsible, showMore:true};

	}

	private parseValue(value: string){
		return this.$q((resolve, reject)=>{
            if (!value){
                reject();
                return;
            }
			let valueArr= value.split('$$');
			if (valueArr.length > 1){
                let shifted = valueArr.shift();
				let codesArray= valueArr.filter((s)=>{return s.charAt(0) === 'C'}).map((s)=>{return 'fulldisplay.constants.' + s.slice(1).trim()});
				this.$translate(codesArray).then((translations)=>{
					valueArr= valueArr.map((s)=>{
						switch (s.charAt(0)){
							case 'C': return '$$C'+ translations['fulldisplay.constants.' + s.slice(1).trim()];
                            case 'V': return '$$V'+ s.slice(1);
                            default: return '$$'+s;
						}
					});
                    valueArr.unshift(shifted);
					resolve(valueArr.join(' '));
				});
			}
			else {
				resolve(valueArr.join(' '));
			}
		});
	}

	private parseSourceCodes(value){
		value= value.replace('$$V', '');
		value = 'fulldisplay.datasource.'+value;
		return value;
	}

	public parseDetails(res) {

		//console.log('mtCacheService ' +JSON.stringify( mtCacheService.getTable('mla_subject_headers_relators')));

		//let parseItemWithRes = angular.bind(this, this.parseItem , res);
		return this.configurationUtil.getFullViewConfiguration().resultitemview.map((item)=>this.parseItem(res,item)).filter(this.filterEmpty);
	}

	parseValueFromComplexType(complexType, item) {
		return item[complexType];
	}

	private getFieldConfig(label) {
		let config = this.fieldsDetails[label];
		if (!config && this.isLdsField(label)) { //check for lds
			config = this.fieldsDetails.lds;
		}
		return config;
	}

    private isLdsField(label){
        let ldsIndex = label.indexOf('lds');
        let ldsNo:Number = label.substring(ldsIndex+3);
        if (ldsIndex ===0 && (ldsNo>29 && ldsNo < 40)) { //check for lds
            return true;
        }
        return false
	}
	
	private checkMoreThanOneOccurance(targetValues: string[], splitValues:string[]) : boolean{
		for(let targetValue of targetValues){
			for(let splitValue of splitValues){
				if(targetValue.split(splitValue).length - 1 > 1){
					return true;
				}
			}
		}
		return false;
	}
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/details/serviceDetails.service.ts